<template>
  <div class="newsletter-page inner">
    <site-menu theme="dark" class="menu"/>
    <form @submit.stop.prevent="send">
      <div class="field-group">
        <h1>Register to our Newsletter</h1>
        <div class="row">
          <div class="field">
            <transition name="fade">
              <label v-if="email">Email</label>
            </transition>
            <input name="email" v-validate="'required'" v-model="email" placeholder="Email *" />
            <span class="error">{{ errors.first('email') }}</span>
          </div>
        </div>
      </div>
      <button type="submit">submit</button>
    </form>
    <divider />
    <illustration />
  </div>
</template>
<script>
  import Illustration from '@/components/Illustration.vue'
  import SiteMenu from '@/components/SiteMenu.vue'
  import Divider from '@/components/Divider.vue'

  export default {
    name: 'newsletter-page',
    components: { Illustration, SiteMenu, Divider },
    data() {
      return {
        email: '',
      }
    },
    methods: {
      send() {
        this.$validator.validateAll().then((result) => {
          if (result) {
            this.$http.post('email', { email: this.email })
            .then(() => {
              this.$toasted.success(`${this.email} is subscribed to our newsletter`)
              this.email = ''
            })
            .catch(res => {
              this.$toasted.error(res.body.error)
            })
          }
        })
      },
    },
  }
</script>
<style lang="scss" scoped>
  .field-group {
    overflow: hidden;
    margin: 40px 0 20px;
    background: $color-8;
    padding: 40px;
    .field input {
      background: $color-8;
      color: #fff;
      border-bottom: 1px solid rgba(255, 255, 255, 0.7);
      padding: 15px 0;
    }
    .field label {
      color: #fff;
      opacity: 0.5;
      top: 2px;
      left: 0;
    }
    ::placeholder {
      color: $color-9;
      opacity: 1;
    }
    :-ms-input-placeholder {
      color: $color-9;
    }
    ::-ms-input-placeholder {
      color: $color-9;
    }
  }
  h1 {
    text-align: center;
    color: #fff;
    font-weight: 100;
    margin: 0;
    text-transform: uppercase;
  }
  form {
    width: 100%;
    overflow: hidden;
    .field {
      margin: 12px;
      input {
        width: 100%;
      }
    }
    textarea {
      margin: 24px 12px 12px 12px;
      box-sizing: border-box;
      width: calc(100% - 24px);
      border: 0;
      height: 300px;
      resize: none;
      padding: 15px;
      font-size: 22px;
    }
    button {
      border: 0;
      background: transparent;
      color: $color-2;
      width: 200px;
      margin: 0 auto;
      text-transform: uppercase;
      display: block;
      font-size: 40px;
      font-weight: normal;
    }
  }
  .error {
    position: absolute;
    left: 0;
    bottom: -13px;
    width: 400px;
    color: lighten($red, 30%);
    font-weight: bold;
    font-size: 10px;
    letter-spacing: 1px;
  }
  .row {
    overflow: hidden;
  }
  .message {
    position: relative;
    .error {
      left: 15px;
      bottom: 0;
    }
  }
  @media (max-width: 500px) {
    form {
      .field {
        width: calc(100% - 24px);
      }
    }
  }

</style>
